import { useState } from "react";
// @shopify/polaris
import { Modal, Text, TextField, BlockStack } from "@shopify/polaris";
// hooks
import useLocales from "../../../hooks/useLocales";
import { ONBOARDING_URL } from "../../../common/constants";

const WriteReview = ({ open, loading, onClose, onWriteReview }) => {
  const { translate } = useLocales();

  const [review, setReview] = useState("");

  const handleWriteReview = () => {
    onWriteReview(review.trim());
  };

  const handleRedirectToOnboarding = () => {
    window.open(ONBOARDING_URL, "_blank").focus();
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={translate("page.dashboard.write-review-modal-title")}
      primaryAction={{
        content: translate("page.dashboard.review-modal-button"),
        onAction: handleWriteReview,
        loading,
        disabled: !review,
      }}
      secondaryActions={[
        {
          content: translate("page.dashboard.review-modal-button-talk-to-someone"),
          onAction: handleRedirectToOnboarding,
          loading,
        },
      ]}
    >
      <Modal.Section>
        <BlockStack gap="600">
          <Text variant="bodyMd" color="subdued">
            {translate("page.dashboard.write-review-modal-body")}
          </Text>

          <TextField
            label={translate("page.dashboard.write-review-modal-label")}
            placeholder={translate("page.dashboard.write-review-modal-label")}
            multiline={3}
            fullWidth
            maxRows={6}
            minRows={3}
            value={review}
            onChange={(value) => setReview(value)}
          />
        </BlockStack>
      </Modal.Section>
    </Modal>
  );
};

export default WriteReview;
